export default {
  toBase64(file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  },
  types: {
    RUT_FRONT: 'RUT_FRONT',
    RUT_BACK: 'RUT_BACK',
    EMPOWERED_TO_SIGN_POWER: 'EMPOWERED_TO_SIGN_POWER',
  },
};
